/**
 * Lens Hook - TanStack Query hook for lens resolution
 */

import { useQuery } from '@tanstack/react-query';
import { query } from '@/lib/graphql';
import { GET_MY_LENS, type GetMyLensResponse, type ResolvedLens } from '@/lib/graphql/lens';

export function useLens(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['myLens'],
    queryFn: async (): Promise<ResolvedLens> => {
      const response = await query<GetMyLensResponse>(GET_MY_LENS);
      return response.myLens;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes, same as useCapabilities
    enabled: options?.enabled ?? true,
  });
}
